// extracted by mini-css-extract-plugin
export default {"container":"sE-z","modal":"tE-z","dimensions":"uE-z","brandName":"vE-z","productName":"wE-z","labelValue":"xE-z","recipientEmail":"yE-z","recommendedFit":"zE-z","hiddenField":"AE-z"};